import { formatDate } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize, map, take } from 'rxjs';
import { EndOutboundScan } from 'src/app/components/shared/table/end-outbound-scan-table/end-outbound-scan-table.constant';
import { Movements } from 'src/app/core/models/position-operations/end-outbound-scan-gle';
import { EndOutboundScanGleService } from 'src/app/core/services/position-operations/end-outbound-scan-gle/end-outbound-scan-gle.service';
import { DataUtils } from 'src/app/core/utils/data/data.utils';
import { CONST } from '../end-outbound-scan-gle.constant';
import { EndScanSuccessfulModalComponent } from '../end-scan-successful-modal/end-scan-successful-modal.component';

@Component({
  selector: 'app-confirm-end-of-outbound-modal',
  templateUrl: './confirm-end-of-outbound-modal.component.html',
  styleUrls: ['./confirm-end-of-outbound-modal.component.scss'],
  standalone: false,
})
export class ConfirmEndOfOutboundModalComponent {
  private readonly _endOutboundScanGleService = inject(
    EndOutboundScanGleService,
  );
  private readonly _dataUtils = inject(DataUtils);

  readonly CONST = {
    ...CONST.CONFIRM_END_SCAN_MODAL,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EndOutboundScan & { index: number },
    public dialogRef: MatDialogRef<ConfirmEndOfOutboundModalComponent>,
    private dialog: MatDialog,
  ) {}

  /**
   * Used to show success modal
   *
   * @memberof ConfirmEndOfOutboundModalComponent
   */
  endOutboundScan() {
    const { index, ...movementData } = this.data;
    const movementRequest = {
      ...movementData,
      departDate: formatDate(movementData.departDate, 'yyyy-MM-dd', 'en-US'),
      sortDate: formatDate(movementData.sortDate || '', 'yyyy-MM-dd', 'en-US'),
    } as unknown as Movements;
    this._endOutboundScanGleService
      .closeMovement(movementRequest)
      .pipe(
        take(1),
        map((closeMovementsResponseResponse) => {
          const message = closeMovementsResponseResponse?.response;
          this._dataUtils.endOutboundScan$.next(this.data);
          this.dialog.open(EndScanSuccessfulModalComponent, {
            width: '24.38rem',
            disableClose: true,
            autoFocus: false,
            data: { ...movementData, index, message },
          });
        }),
        finalize(() => {
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }
}
